<template>
    <div style='width: 100%'>
        <h2 class="section-title">{{ $t('release.title') }}</h2>
        <el-table :data="tableData" >
            <el-table-column prop="time" :label="$t('release.colTime')" align='center' width="140px"></el-table-column>
            <el-table-column prop="ver" :label="$t('release.colVer')" align='center' width="120px"></el-table-column>
            <el-table-column width="540px">
                <template slot="header" slot-scope="scope">
                    <el-input v-model="search"  size="mini" :placeholder="$t('release.searchPlaceholder')" clearable @clear="getTableData" @keyup.enter.native="getTableData">
                      <el-button slot="append" icon="el-icon-search" @click="getTableData"></el-button>
                    </el-input>
                </template>
                <template slot-scope="props">
                    <p v-for="(item,index) in props.row.update" :key="index">
                        {{index+1 + ". " + item}}
                    </p>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[5, 10, 15, 25]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
      </el-pagination>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      tableWidth: '',
      pagination: {
        total: 0,
        pageSize: 5,
        currentPage: 1
      },
      search: '',
      tableData: []
    }
  },
  computed: {
    releaseData () {
      return this.$t('release.items')
    }
  },
  watch: {
    '$lang' () {
      this.getTableData()
    }
  },
  methods: {
    getTableData () {
      if (this.search === '') {
        this.tableData = this.releaseData
      } else {
        this.tableData = []
        this.releaseData.forEach(item => {
          var bret = item.update.some(subitem => { // some function needs a return clause!
            return subitem.includes(this.search.trim())
          })
          if (bret) this.tableData.push(item)
        })
      }
      this.pagination.total = this.tableData.length
      var offset = (this.pagination.currentPage - 1) * this.pagination.pageSize
      this.tableData = this.$_.drop(this.tableData, offset).slice(0, this.pagination.pageSize)
    },

    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.getTableData()
    },

    handleCurrentChange (curPage) {
      this.pagination.currentPage = curPage
      this.getTableData()
    }
  },
  created () {
    this.getTableData()
  }
}
</script>

<style scoped>

.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
